import {
  BrandingTheme,
  Partner,
  akademikernePartners,
} from "./partnerInterfaces";

import { ReduxState } from "Store/rootReducer";
import { useSelector } from "react-redux";
import { partnerIdSelector } from "./partnerSelectors";

export const useBrandingTheme = (): BrandingTheme => {
  const { partner } = useSelector((state: ReduxState) => state);
  return partner.brandingTheme;
};

export const usePartnerAgreementNumber = (): number | undefined => {
  const { partner } = useSelector((state: ReduxState) => state);
  return partner.agreementNumber;
};

export const usePartnerId = (): string => useSelector(partnerIdSelector);

export const useIsPartnerBranding = (): boolean =>
  useIsAkademikerneBranding() ||
  useIsCoopBranding() ||
  useIsHuseierneBranding();

export const useIsPartnerAgreement = (): boolean =>
  useIsAkademikerneAgreement() ||
  useIsCoopAgreement() ||
  useIsHuseierneAgreement();

export const useIsCoopBranding = (): boolean => {
  const { partner } = useSelector((state: ReduxState) => state);
  return partner.brandingTheme?.id === Partner.COOP;
};

export const useIsCoopAgreement = (): boolean => {
  const { partner } = useSelector((state: ReduxState) => state);
  return partner.partnerId === Partner.COOP;
};

export const useIsAkademikerneAgreement = (): boolean => {
  const { partner } = useSelector((state: ReduxState) => state);
  return akademikernePartners.some((aka) => partner.partnerId === aka);
};

export const useIsAkademikerneBranding = (): boolean => {
  const { partner } = useSelector((state: ReduxState) => state);
  return akademikernePartners.some((aka) => partner.brandingTheme?.id === aka);
};

export const useIsHuseierneBranding = (): boolean => {
  const { partner } = useSelector((state: ReduxState) => state);
  return partner.brandingTheme?.id === Partner.HUSEIERNE;
};

export const useIsHuseierneAgreement = (): boolean => {
  const { partner } = useSelector((state: ReduxState) => state);
  return partner.partnerId === Partner.HUSEIERNE;
};
